module.exports = __webpack_public_path__ + "img/cabbage-clean-large.b556fc0c.png";